import ParticlesBg from "particles-bg";
import { useState, useEffect } from "react";

export const Header = (props) => {
  // Add state to manage particle scale based on screen size
  const [particleScale, setParticleScale] = useState(1);

  // Add effect to check window size and update particle scale
  useEffect(() => {
    // Function to handle responsive changes
    const handleResize = () => {
      // Check if window width is mobile size (typically under 768px)
      if (window.innerWidth <= 768) {
        setParticleScale(0.1); // Small scale for mobile
      } else {
        setParticleScale(1); // Normal scale for desktop
      }
    };

    // Set initial scale
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header id='header'>
      <div className='intro' style={{ backgroundImage: "url('./img/03.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        {/* Particles container with dynamic scale */}
        <div className="particles-container">
          <ParticlesBg
            num={4}
            rps={0.2}
            life={3}
            g={1}
            scale={particleScale} 
            type="circle"
            color={"#027a23"}
            bg={{zIndex: 0, position:"absolute", top:0}}
          />
        </div>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
            <div className='col-md-8 col-md-offset-2 intro-text'>
                <img src='img/logo.png' alt='RecycleMore Logo' style={{ maxWidth: '13em', marginBottom: '20px', display: 'block', margin: '0 auto 20px auto' }} />
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}</p>
                <a
                  href='#features'
                  className='btn btn-custom btn-lg page-scroll'
                >
                  Loe veel
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}